export default {
    primary: '#855f42',
    primaryDark: '#352b28',
    secondary: '#bb9a83',
    background: '#fff3df'
}
